/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (zone, parent)
  {
    this.zone = zone;
    this.parent = parent;

    this.hex = zone.getDisplayHex().transformWithObject(parent.transform);
  }


  get cass ()
  {
    return this.zone.cass;
  }


  getNeighbor (index)
  {
    const displayHex = this.hex.getNeighborsInOrder()[index];

    return this.parent.getZone(displayHex);
  }


  getNeighbors ()
  {
    return this.hex.getNeighborsInOrder().map(displayHex => this.parent.getZone(displayHex));
  }


  isExternalBorder (neighbor)
  {
    return this.zone.isExternalBorder(neighbor !== null ? neighbor.zone : null);
  }


  isTemporaryBorder (neighbor)
  {
    return this.zone.isTemporaryBorder(neighbor !== null ? neighbor.zone : null);
  }


  isGroupBorder (neighbor)
  {
    return this.zone.isGroupBorder(neighbor !== null ? neighbor.zone : null);
  }


  isJaggedBorder (neighbor)
  {
    return this.zone.isJaggedBorder(neighbor !== null ? neighbor.zone : null);
  }



  isEmphasized ()
  {
    return this.zone.isEmphasized();
  }


  isDimmed ()
  {
    return this.zone.isDimmed();
  }


  getBeaconValue ()
  {
    return this.zone.getBeaconValue();
  }


  isEstablished ()
  {
    return this.zone.isEstablished();
  }


  getBackgroundBand (now)
  {
    return this.zone.getBackgroundBand(now);
  }


  getDisplayHex ()
  {
    return this.hex;
  }


  getEntityHex ()
  {
    return this.zone.getEntityHex();
  }


  getColor ()
  {
    return this.zone.getColor();
  }


  equals (other)
  {
    return other?.constructor === this.constructor && this.zone.equals(other.zone) && this.parent.equals(other.parent);
  }


};
